/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';
import { LucideEye, LucideEyeOff } from '@lucide/angular';
import { PrearrivalsLoginFormComponent } from '../prearrivals-login-form/prearrivals-login-form.component';

@Component({
  selector: 'ptl-v3-prearrivals-login-form',
  templateUrl: './v3-prearrivals-login-form.component.html',
  styleUrls: ['./v3-prearrivals-login-form.component.scss'],
})
export class V3PrearrivalsLoginFormComponent extends PrearrivalsLoginFormComponent {
  protected readonly LucideEye = LucideEye;
  protected readonly LucideEyeOff = LucideEyeOff;
}
